"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var models_1 = require("./models");
var mobx_react_1 = require("mobx-react");
var shared_1 = require("../../../shared");
var Wrapper_1 = __importDefault(require("./styledComponents/Wrapper"));
var StartDate_1 = __importDefault(require("./styledComponents/StartDate"));
var EndDate_1 = __importDefault(require("./styledComponents/EndDate"));
var CalendarDateWrapper_1 = __importDefault(require("./styledComponents/CalendarDateWrapper"));
var CalendarDateLabel_1 = __importDefault(require("./styledComponents/CalendarDateLabel"));
var Translate_1 = require("../Translate/Translate");
var DateSelection_meta_1 = require("./DateSelection.meta");
var mobx_1 = require("mobx");
var ksys_app_template_1 = require("@kurtosys/ksys-app-template");
var CalendarStartDate_1 = __importDefault(require("./styledComponents/CalendarStartDate"));
var CalendarEndDate_1 = __importDefault(require("./styledComponents/CalendarEndDate"));
var DatePickerUtils_1 = require("../DatePicker/DatePickerUtils");
var DateSelection = /** @class */ (function (_super) {
    __extends(DateSelection, _super);
    function DateSelection(props) {
        var _this = _super.call(this, props) || this;
        _this.categoryKey = DateSelection_meta_1.DATE_SELECTION_CATEGORY_KEY;
        _this.componentKey = DateSelection_meta_1.DATE_SELECTION_COMPONENT_KEY;
        _this.items = [];
        _this.initialize = function () {
            var _a = _this.props.mode, mode = _a === void 0 ? models_1.DateSelectionMode.dropdown : _a;
            if (mode === models_1.DateSelectionMode.dropdown) {
                _this.initialiseDropdownItems();
            }
        };
        _this.dateRangesDiffer = function (oldRange, newRange) {
            return !(oldRange === newRange ||
                (oldRange &&
                    newRange &&
                    ksys_app_template_1.utils.json.stringifySafe(oldRange) === ksys_app_template_1.utils.json.stringifySafe(newRange)));
        };
        _this.getDateAsDropdownItem = function (date) {
            return {
                value: date,
                label: _this.format
                    ? ksys_app_template_1.utils.formatter.formatter(_this.format, date)
                    : date,
            };
        };
        _this.isDateAllowed = function (date) {
            var isInAllowed = _this.allowedValues.find(function (value) {
                var allowedDate = DatePickerUtils_1.printISODateFromString(value);
                var currentDate = DatePickerUtils_1.printISODate(date);
                return allowedDate === currentDate;
            });
            return isInAllowed !== undefined;
        };
        _this.isStartDateDisabled = function (date) {
            var isDateAllowed = _this.isDateAllowed(date);
            var hasEndDate = !ksys_app_template_1.utils.typeChecks.isNullOrEmpty(_this.selectedCalendarEndDate);
            var isAfterEndDate = !hasEndDate || (hasEndDate && date > _this.selectedCalendarEndDateAsDate);
            return !isDateAllowed || isAfterEndDate;
        };
        _this.isEndDateDisabled = function (date) {
            var isDateAllowed = _this.isDateAllowed(date);
            var hasStartDate = !ksys_app_template_1.utils.typeChecks.isNullOrEmpty(_this.selectedCalendarStartDate);
            var isBeforeStartDate = !hasStartDate || (hasStartDate && date < _this.selectedCalendarStartDateAsDate);
            return !isDateAllowed || isBeforeStartDate;
        };
        _this.initialize();
        return _this;
    }
    DateSelection.prototype.componentDidUpdate = function (previousProps) {
        if (this.dateRangesDiffer(previousProps.dateRange, this.props.dateRange)) {
            this.initialize();
        }
    };
    DateSelection.prototype.initialiseDropdownItems = function () {
        var _this = this;
        var _a = this.props.dateRange, dateRange = _a === void 0 ? [] : _a;
        this.items = dateRange.map(function (date) { return _this.getDateAsDropdownItem(date); });
    };
    Object.defineProperty(DateSelection.prototype, "format", {
        get: function () {
            var _a = this.props, formatOverride = _a.formatOverride, _b = _a.dateFormat, dateFormat = _b === void 0 ? 'date' : _b;
            var globalFormat = this.globalConfiguration &&
                this.globalConfiguration.formats &&
                this.globalConfiguration.formats[dateFormat];
            var format = formatOverride || globalFormat;
            if (format) {
                if (!format.locale) {
                    format.locale =
                        this.translationContext && this.translationContext.culture;
                }
                if (!format.options) {
                    format.options = {};
                }
            }
            return format;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DateSelection.prototype, "startDateProps", {
        get: function () {
            var _this = this;
            var _a = this.props, onChange = _a.onChange, startDateProps = _a.startDateProps;
            var selectedItem = !ksys_app_template_1.utils.typeChecks.isNullOrEmpty(this.selectedDropdownStartDate)
                ? this.getDateAsDropdownItem(this.selectedDropdownStartDate)
                : undefined;
            var onChangeEvent = function (item) {
                if (startDateProps) {
                    startDateProps.value = item.value;
                    if (onChange) {
                        onChange(item.value, _this.selectedDropdownEndDate);
                    }
                }
            };
            return {
                selectedItem: selectedItem,
                items: ksys_app_template_1.utils.typeChecks.isNullOrEmpty(this.selectedDropdownEndDate)
                    ? this.items
                    : this.items.filter(function (item) { return item.value <= _this.selectedDropdownEndDate; }),
                placeholder: (startDateProps && startDateProps.placeholder) || 'Start Date',
                label: startDateProps && startDateProps.label,
                onChange: onChangeEvent,
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DateSelection.prototype, "endDateProps", {
        get: function () {
            var _this = this;
            var _a = this.props, onChange = _a.onChange, endDateProps = _a.endDateProps;
            var selectedItem = !ksys_app_template_1.utils.typeChecks.isNullOrEmpty(this.selectedDropdownEndDate)
                ? this.getDateAsDropdownItem(this.selectedDropdownEndDate)
                : undefined;
            var onChangeEvent = function (item) {
                if (endDateProps) {
                    endDateProps.value = item.value;
                    if (onChange) {
                        onChange(_this.selectedDropdownStartDate, item.value);
                    }
                }
            };
            return {
                selectedItem: selectedItem,
                items: ksys_app_template_1.utils.typeChecks.isNullOrEmpty(this.selectedDropdownStartDate)
                    ? this.items
                    : this.items.filter(function (item) { return item.value >= _this.selectedDropdownStartDate; }),
                placeholder: (endDateProps && endDateProps.placeholder) || 'End Date',
                label: endDateProps && endDateProps.label,
                onChange: onChangeEvent,
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DateSelection.prototype, "allowedValues", {
        get: function () {
            var _a = this.props.dateRange, dateRange = _a === void 0 ? [] : _a;
            return dateRange;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DateSelection.prototype, "calendarStartDateProps", {
        get: function () {
            var _this = this;
            var _a = this.props, onChange = _a.onChange, calendarStartDateProps = _a.calendarStartDateProps;
            var onChangeEvent = function (value) {
                if (calendarStartDateProps) {
                    calendarStartDateProps.value = value;
                    if (onChange) {
                        onChange(value, _this.selectedCalendarEndDate);
                    }
                }
            };
            return __assign(__assign({}, calendarStartDateProps), { value: this.selectedCalendarStartDate, isDateDisabled: this.isStartDateDisabled, onChange: onChangeEvent });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DateSelection.prototype, "calendarEndDateProps", {
        get: function () {
            var _this = this;
            var _a = this.props, onChange = _a.onChange, calendarEndDateProps = _a.calendarEndDateProps;
            var onChangeEvent = function (value) {
                if (calendarEndDateProps) {
                    calendarEndDateProps.value = value;
                    if (onChange) {
                        onChange(_this.selectedCalendarStartDate, value);
                    }
                }
            };
            return __assign(__assign({}, calendarEndDateProps), { value: this.selectedCalendarEndDate, isDateDisabled: this.isEndDateDisabled, onChange: onChangeEvent });
        },
        enumerable: true,
        configurable: true
    });
    DateSelection.prototype.displayDate = function (selectedDate, translationContext) {
        var culture = translationContext.culture, translate = translationContext.translate;
        return this.format
            ? ksys_app_template_1.utils.formatter.formatter(this.format, selectedDate, translate)
            : ksys_app_template_1.utils.formatter.formatDateTime(culture, {}, selectedDate);
    };
    Object.defineProperty(DateSelection.prototype, "calendarStartLabel", {
        get: function () {
            var calendarStart = this.props.calendarStartDateProps;
            return (calendarStart && calendarStart.label) || 'Start Date';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DateSelection.prototype, "calendarEndLabel", {
        get: function () {
            var calendarEnd = this.props.calendarEndDateProps;
            return (calendarEnd && calendarEnd.label) || 'End Date';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DateSelection.prototype, "selectedDropdownStartDate", {
        get: function () {
            var _a = this.props, startDateProps = _a.startDateProps, _b = _a.dateRange, dateRange = _b === void 0 ? [] : _b;
            var startDate = startDateProps && startDateProps.value;
            if (startDate && dateRange.includes(startDate)) {
                return startDate;
            }
            return '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DateSelection.prototype, "selectedDropdownEndDate", {
        get: function () {
            var _a = this.props, startDateProps = _a.startDateProps, endDateProps = _a.endDateProps, _b = _a.dateRange, dateRange = _b === void 0 ? [] : _b;
            var startDate = startDateProps && startDateProps.value;
            var endDate = endDateProps && endDateProps.value;
            if (endDate && dateRange.includes(endDate)) {
                if (!startDate || startDate <= endDate) {
                    return endDate;
                }
            }
            return '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DateSelection.prototype, "selectedCalendarStartDate", {
        get: function () {
            var calendarStartDateProps = this.props.calendarStartDateProps;
            var startDate = calendarStartDateProps && calendarStartDateProps.value;
            if (startDate && this.allowedValues.includes(startDate)) {
                var date = DatePickerUtils_1.printISODateFromString(startDate);
                return date;
            }
            return '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DateSelection.prototype, "selectedCalendarStartDateAsDate", {
        get: function () {
            return DatePickerUtils_1.parseISODate(this.selectedCalendarStartDate) || new Date();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DateSelection.prototype, "selectedCalendarEndDate", {
        get: function () {
            var _a = this.props, calendarStartDateProps = _a.calendarStartDateProps, calendarEndDateProps = _a.calendarEndDateProps;
            var startDate = calendarStartDateProps && calendarStartDateProps.value;
            var endDate = calendarEndDateProps && calendarEndDateProps.value;
            if (endDate && this.allowedValues.includes(endDate)) {
                if (!startDate || startDate <= endDate) {
                    return DatePickerUtils_1.printISODateFromString(endDate);
                }
            }
            return '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DateSelection.prototype, "selectedCalendarEndDateAsDate", {
        get: function () {
            return DatePickerUtils_1.parseISODate(this.selectedCalendarEndDate) || new Date();
        },
        enumerable: true,
        configurable: true
    });
    DateSelection.prototype.render = function () {
        var _this = this;
        var _a = this.props, className = _a.className, _b = _a.mode, mode = _b === void 0 ? models_1.DateSelectionMode.dropdown : _b;
        return (react_1.default.createElement(Wrapper_1.default, { className: className },
            react_1.default.createElement(Translate_1.TranslationContext.Consumer, null, function (translationContext) {
                _this.translationContext = translationContext;
                return (react_1.default.createElement(react_1.default.Fragment, null,
                    mode === models_1.DateSelectionMode.dropdown && (react_1.default.createElement(react_1.Fragment, null,
                        react_1.default.createElement(StartDate_1.default, __assign({}, _this.startDateProps)),
                        react_1.default.createElement(EndDate_1.default, __assign({}, _this.endDateProps)))),
                    mode === models_1.DateSelectionMode.calendar && (react_1.default.createElement(react_1.Fragment, null,
                        react_1.default.createElement(CalendarDateWrapper_1.default, null,
                            react_1.default.createElement(CalendarDateLabel_1.default, null, _this.calendarStartLabel),
                            react_1.default.createElement(CalendarStartDate_1.default, __assign({}, _this.calendarStartDateProps))),
                        react_1.default.createElement(CalendarDateWrapper_1.default, null,
                            react_1.default.createElement(CalendarDateLabel_1.default, null, _this.calendarEndLabel),
                            react_1.default.createElement(CalendarEndDate_1.default, __assign({}, _this.calendarEndDateProps)))))));
            })));
    };
    DateSelection.contextType = Translate_1.TranslationContext;
    __decorate([
        mobx_1.action
    ], DateSelection.prototype, "initialize", void 0);
    __decorate([
        mobx_1.action
    ], DateSelection.prototype, "initialiseDropdownItems", null);
    __decorate([
        mobx_1.computed
    ], DateSelection.prototype, "startDateProps", null);
    __decorate([
        mobx_1.computed
    ], DateSelection.prototype, "endDateProps", null);
    __decorate([
        mobx_1.computed
    ], DateSelection.prototype, "allowedValues", null);
    __decorate([
        mobx_1.computed
    ], DateSelection.prototype, "calendarStartDateProps", null);
    __decorate([
        mobx_1.computed
    ], DateSelection.prototype, "calendarEndDateProps", null);
    __decorate([
        mobx_1.computed
    ], DateSelection.prototype, "calendarStartLabel", null);
    __decorate([
        mobx_1.computed
    ], DateSelection.prototype, "calendarEndLabel", null);
    __decorate([
        mobx_1.computed
    ], DateSelection.prototype, "selectedDropdownStartDate", null);
    __decorate([
        mobx_1.computed
    ], DateSelection.prototype, "selectedDropdownEndDate", null);
    __decorate([
        mobx_1.computed
    ], DateSelection.prototype, "selectedCalendarStartDate", null);
    __decorate([
        mobx_1.computed
    ], DateSelection.prototype, "selectedCalendarStartDateAsDate", null);
    __decorate([
        mobx_1.computed
    ], DateSelection.prototype, "selectedCalendarEndDate", null);
    __decorate([
        mobx_1.computed
    ], DateSelection.prototype, "selectedCalendarEndDateAsDate", null);
    DateSelection = __decorate([
        mobx_react_1.observer
    ], DateSelection);
    return DateSelection;
}(shared_1.ComponentBase));
exports.DateSelection = DateSelection;
exports.default = shared_1.InjectedStyledComponent(DateSelection, DateSelection_meta_1.DATE_SELECTION_CATEGORY_KEY, DateSelection_meta_1.DATE_SELECTION_COMPONENT_KEY);
